import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { useEffect } from "react";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ThankYou from "@/pages/ThankYou";
import { initAnalytics } from "@/lib/analytics";
import { injectTracking } from "@/lib/tracking";
import { api } from "@/lib/api";
import { LangProvider } from "@/lib/i18n";
import "@/App.css";

function App() {
  useEffect(() => {
    initAnalytics();
    api.get("/settings").then(({ data }) => injectTracking(data)).catch(() => {});
  }, []);
  return (
    <div className="App">
      <LangProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="bottom-center"
          toastOptions={{
            className: "font-mono",
            style: { borderRadius: 0, border: "1px solid hsl(var(--border))" },
          }}
        />
      </LangProvider>
    </div>
  );
}

export default App;
